import * as React from 'react';
import {useState} from 'react';
import {uniq} from 'ramda';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import {ArrowLeft, Ok} from '../common/btns';

const css = require('./product-picker.css').default;
const headerCss = require('../common/header.css').default;

export default function({products, onDone}: {
    products: product[],
    onDone: (codes: string[]) => void,
}) {
    const [codes, setCodes] = useState<string[]>([]);

    return (
    <>
        <div id={headerCss.header}>
            <ArrowLeft width={25} height={25} onClick={() => onDone([])}/>
            <div className='space'/>
            <Ok width={25} height={25} color='green' onClick={() => onDone(codes)}/>
        </div>
        <ListGroup className={css.products}>
            {(() => {
                return products
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(i => (
                    <ListGroup.Item key={i.code}>
                        <Form.Check type='checkbox' id={`chk-${i.code}`} label={i.name}
                            onChange={e => {
                                if (e.target.checked) {
                                    setCodes(codes => uniq(codes.concat([i.code])));
                                } else {
                                    setCodes(codes => codes.filter(code => code !== i.code));
                                }
                            }}/>
                    </ListGroup.Item>
                ));
            })()}
        </ListGroup>
    </>);
}

type product = {
    code: string,
    name: string,
    memo: string | null,
}
